import './ToolsStatistics.scss';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCheckSquare, faEdit, faUser } from '@fortawesome/free-solid-svg-icons';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ToolsStatisticsContentContainer } from '../containers/ToolsStatisticsContent.container';
import { ToolsStatisticsSidebarContainer } from '../containers/ToolsStatisticsSidebar.container';

library.add(faEdit, faUser, faCheckSquare);

export const ToolsStatistics = observer((): ReactElement => {
  return (
    <div className='tool-statistics'>
      <ToolsStatisticsSidebarContainer />
      <ToolsStatisticsContentContainer />
    </div>
  );
});
